import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import '../styles/Stats.css';

function Stats() {
  const { ref, inView } = useInView({
    threshold: 0.3,
  });

  const [visible, setVisible] = useState(false);

  // Track when inView toggles to re-trigger animation and CountUp
  useEffect(() => {
    if (inView) {
      setVisible(true);
      setTimeout(() => setVisible(false), 1000); // Reset for retrigger
    }
  }, [inView]);

  const stats = [
    { label: 'Years of Excellence', value: 75 },
    { label: 'Core Businesses', value: 4 },
    { label: 'Employees', value: 14000 },
    { label: 'Educational Institutes', value: 5 },
    { label: 'Hospitals', value: 2 },
  ];

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div
            className={`stat-box ${inView ? 'come-up' : ''}`}
            key={index}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <h3>
              {inView && (
                <CountUp
                  end={stat.value}
                  duration={2.5}
                  key={visible ? `count-${index}-${Date.now()}` : `idle-${index}`}
                />
              )}
              +
            </h3>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
